"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrderEnum = void 0;
var SortOrderEnum;
(function (SortOrderEnum) {
    SortOrderEnum["Ascending"] = "ASC";
    SortOrderEnum["Descending"] = "DESC";
})(SortOrderEnum = exports.SortOrderEnum || (exports.SortOrderEnum = {}));
